import React from 'react';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const InfoCard = (props) => {
  const { title, primaryGap, primaryValue, secondaryGap, secondaryValue, delta, positiveDelta } =
    props;

  const { t } = useAutoTranslation();

  return (
    <div className="col-md-6 col-xl-3">
      <div className="card-box">
        <h4 className="mt-0 font-15">{title}</h4>
        {primaryValue && secondaryValue ? (
          <>
            <p className="mt-3 mb-0 text-center text-muted">{primaryGap}</p>
            <h2 className="text-primary mt-0 mb-3 text-center font-weight-normal">
              {primaryValue}
            </h2>
            <p className="text-muted mb-0">
              {secondaryGap}: {secondaryValue}
              <span className="float-right">
                <i
                  className={`fa ${
                    positiveDelta ? `fa-caret-up text-success` : `fa-caret-down text-danger`
                  }  mr-1`}
                />
                {delta}%
              </span>
            </p>
          </>
        ) : (
          <p
            style={{
              height: 109,
              margin: `0 -1.5rem`,
              display: `flex`,
              alignItems: `center`,
              justifyContent: `center`,
              color: `#98a6ad`,
              fontSize: `11px`,
              textTransform: `uppercase`,
              fontWeight: `500`,
            }}
          >
            {t('Недостаточно данных')}
          </p>
        )}
      </div>
    </div>
  );
};

export default InfoCard;
